export class ContractItemStatus {
	object = 'launchPadContractItemContractStockCheck'
	id = 0
	pick_reference = 0
	contract_id = ''
	contract_number = ''
	status = ''
	depot = ''
	weight?: number
	pick_number = ''
	tos?: boolean = false
	notes?: string = ''
	resolved?: boolean = false
	notes_status?: null | number = 2
	assigned_to?: null | string
	load_assigned_to?: null | string
	quantity_to_load?: null | number
	quantity_required: number = 0
	quantity_confirmed: number = 0
	quantity_loaded?: number
	delivery_method?: string
	delivery_method_name?: string
	vehicle?: string | null = null
	journey_number?: string | null = null
	has_uniques: boolean = false
	unique_items?: string[]
	item_picked?: string[]
	hire_desk_complete?: boolean
	complete_flag?: boolean
}
